module.exports = __webpack_public_path__ + "static/media/mu.25dc81a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mu.svg
// module id = 199
// module chunks = 0